import { Component, ViewChild, ElementRef } from '@angular/core';
import { PopupService } from '../popup.service';

@Component({
  selector: 'app-iframe',
  template: `<iframe #iframe (load)="load()" [src]="url | urlSafe" *ngIf="url" frameborder="0"></iframe>`
})
export class IframeComponent {

  url: string;

  @ViewChild('iframe') iframe: ElementRef;

  constructor(private popup: PopupService) {}

  load() {
    this.popup.dispatchLoadEvent();
  }
}
